import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import useCollectionState from 'Hooks/useCollectionState';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { ClientLayout } from 'Components/ComponentLibrary/Organisms/ClientLayout';
import { DependentLayout } from 'Components/ComponentLibrary/Organisms/DependentLayout';
import usePrevious from 'Hooks/usePrevious';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

export const ManageHouseholdMember = ({ selectedResource, onDeleteMember }) => {
  const { refreshPageContentCollection } = usePageContentContext();

  const link = selectedResource?.withRelationship(fr.relationships.details.name, (rel) => {
    return rel.link('related');
  }, () => null);
  const { collection: currentCollection } = useCollectionState({ link });
  const prevCollection = usePrevious(currentCollection);
  const collection = currentCollection || prevCollection; // Give preference to new but don't be afraid to render the old one

  if (!collection) {
    return null;
  }

  const [resource] = collection;
  let Layout;
  switch (resource.type()) {
    case 'client':
      Layout = ClientLayout;
      break;
    default:
      Layout = DependentLayout;
      break;
  }

  return (
    <MetaResourceRenderer
      layout={Layout}
      LayoutProps={{
        onSuccessfulSubmit: () => refreshPageContentCollection(),
      }}
      resource={resource}
      onSubmit={() => {
        refreshPageContentCollection();
      }}
      onDelete={onDeleteMember}
    />
  );
};

ManageHouseholdMember.propTypes = {
  selectedResource: PropTypes.object.isRequired,
  onDeleteMember: PropTypes.func.isRequired,
};
